import React from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Form as FormLayout} from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";
import {COUNTRIES} from "../../../../../../util/constants/Countries";
import {POSITIONS} from "../../../../data/EmploymentPositions";
import {EMPLOYMENT_TYPES} from "../../../../data/EmploymentTypes";

function EmploymentDetails(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            employmentData = {}
        }
    }
) {
    const validateEmployed = (status) => {
        return status === "SELF_EMPLOYED" || status === "EMPLOYED";
    }

    const validationSchema = Yup.object({
        status: Yup.string().required('Required'),
        address: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        city: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        company: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        country: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        position: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        state: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        type: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
        zip: Yup.string().when('status', {
            is: validateEmployed,
            then: Yup.string().required('Required'),
        }),
    })

    const compiledInitialValues = {
        status: "",
        address: "",
        city: "",
        company: "",
        country: "",
        position: "",
        state: "",
        type: "",
        zip: "",
        ...employmentData
    }

    return (
        <div>
            <Formik validationSchema={validationSchema} initialValues={compiledInitialValues} validateOnMount={true}
                    enableReinitialize={true}>
                {({isValid, values: {status}}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            <FormLayout.Row>
                                <SelectInput
                                    label="Employment Status*"
                                    name="status"
                                    options={[
                                        {value: "EMPLOYED", name: "Employed"},
                                        {value: "RETIRED", name: "Retired"},
                                        {value: "STUDENT", name: "Student"},
                                        {value: "UNEMPLOYED", name: "Not Employed"},
                                        {value: "SELF_EMPLOYED", name: "Self Employed"},
                                    ]}
                                />
                            </FormLayout.Row>
                            {
                                validateEmployed(status) && <>
                                    <FormLayout.Row>
                                        <TextInput
                                            label="Company Name*"
                                            name="company"
                                            type="text"
                                        />
                                        <SelectInput
                                            label="Employment Type*"
                                            name="type"
                                            options={EMPLOYMENT_TYPES}
                                        />
                                        <SelectInput
                                            label="Position*"
                                            name="position"
                                            options={POSITIONS}
                                        />
                                    </FormLayout.Row>
                                    <FormLayout.Row>
                                        <TextInput
                                            label="Address*"
                                            name="address"
                                            type="text"
                                        />
                                    </FormLayout.Row>
                                    <FormLayout.Row>
                                        <TextInput
                                            label="Zip Code*"
                                            name="zip"
                                            type="text"
                                        />
                                        <TextInput
                                            label="City*"
                                            name="city"
                                            type="text"
                                        />
                                    </FormLayout.Row>
                                    <FormLayout.Row>
                                        <TextInput
                                            label="State* / Province*"
                                            name="state"
                                            type="text"
                                        />
                                        <SelectInput
                                            label="Country*"
                                            name="country"
                                            options={COUNTRIES}
                                        />
                                    </FormLayout.Row>
                                </>
                            }
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default EmploymentDetails;